module.exports = __webpack_public_path__ + "img/diary-clock-active.d65a7b1c.svg";